// eslint-disable-next-line import/prefer-default-export
export const labelMap = {
    'full-address': 'Full Address',
    'address-elements': 'Address Elements',
    'single-service': 'Single Service',
    'multi-service': 'Multi Service',
};
